import { useQuery } from "@tanstack/react-query";
import BusinessForm from "../components/BusinessForm";
import BusinessPreview from "../components/BusinessPreview";
import ContentLayout from "../components/layout/ContentLayout";
import ProgressCard from "../components/ProgressCard";
import { useSelector } from "react-redux";
import { getAccStatus, getBusinesses } from "../actions/acc_actions";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function OverView() {
  const { t } = useTranslation();
  const accUrn = useSelector((state) => state.account.urn);
  const name = useSelector((state) => state.account.name);

  const {
    refetch,
    isLoading: businessLoading,
    data: businessesData,
  } = useQuery({
    queryKey: ["userBusinesses", accUrn],
    queryFn: () => getBusinesses(accUrn),
    enabled: !!accUrn,
  });

  const { isLoading: accStatusLoading, data: accStatusData } = useQuery({
    queryKey: ["accStatus", accUrn],
    queryFn: () => getAccStatus(accUrn),
    enabled: !!accUrn,
  });

  const isLoading =
    accStatusLoading || businessLoading || !!!accStatusData?.data;

  const accounts = accStatusData?.data;
  const accStatus = {
    rewards: accounts?.rewardsCount > 0,
    outlet: accounts?.outletsCount > 0,
    businesses: accounts?.businessesCount > 0,
    stampcards: accounts?.stampcardsCount > 0,
  };

  const selectedBusiness = (() => {
    const saved = localStorage.getItem("selectedBusiness");
    if (!saved || !businessesData?.data) return null;

    const parsed = JSON.parse(saved);
    return (
      businessesData.data.find((b) => b.urn === parsed.businessUrn) || null
    );
  })();

  return isLoading ? null : (
    <ContentLayout
      header={
        <div className="overview-header">
          <div className="overview-header-left">
            <h1>
              {t("welcome")} <br />
              <span>{name}</span>
            </h1>
            <h6 className="subtitle active">{t("notifications")}</h6>
            <div className="notf-cards">
              {!accStatus.outlet && (
                <Link to="/outlets/add" className="notf-card">
                  <img
                    src="/assets/images/icons/icons-pink/market-pink.png"
                    alt=""
                  />
                  <div className="notf-card-content">
                    <h6>{t("add_outlet")}</h6>
                    <p>{t("pending")}</p>
                  </div>
                </Link>
              )}
              {!accStatus.rewards && (
                <Link to="/rewards" className="notf-card">
                  <img
                    src="/assets/images/icons/icons-pink/gift-pink.png"
                    alt=""
                  />
                  <div className="notf-card-content">
                    <h6>{t("account_rewards")}</h6>
                    <p>{t("pending")}</p>
                  </div>
                </Link>
              )}
              {!accStatus.stampcards && (
                <Link to="/stamp-card" className="notf-card">
                  <img
                    src="/assets/images/icons/icons-pink/building-pink.png"
                    alt=""
                  />
                  <div className="notf-card-content">
                    <h6>{t("create_stamp_card")}</h6>
                    <p>{t("pending")}</p>
                  </div>
                </Link>
              )}
            </div>
          </div>
          <ProgressCard account={accounts} />
        </div>
      }
    >
      {selectedBusiness ? (
        <BusinessPreview data={selectedBusiness} refetch={refetch} />
      ) : (
        <BusinessForm refetch={() => refetch()} />
      )}
    </ContentLayout>
  );
}
